import TableContainer from "@/components/_table-container";
import CreateThiSensorModal from "@/components/_modals/create-thi-sensor";
import { RoleTypes } from "@/constants/role_types";

import { mapState, mapActions } from "vuex";

export default {
  name: "ThiSensors",
  components: { TableContainer, CreateThiSensorModal },
  data() {
    return {
      createModalVisible: false,
      searchText: "",
      sensorsPerPage: 100,
      page: 1,
      totalPages: 1,
      sortBy: {
        key: undefined,
        direction: undefined
      },
      headers: [
        { sortByKey: "name", text: this.$t("thiSensorGenerics.name") },
        { sortByKey: "deveui", text: this.$t("thiSensorGenerics.deveui") },
        { sortByKey: "temp", text: this.$t("thiSensorGenerics.temp") },
        { sortByKey: "humidity", text: this.$t("thiSensorGenerics.humidity") },
        { sortByKey: "thi", text: this.$t("thiSensorGenerics.thi") },
        { sortByKey: "avg_48h_thi", text: this.$t("thiSensorGenerics.avg48hThi") },
        { sortByKey: "highest_48h_thi", text: this.$t("thiSensorGenerics.highest48hThi") },
        { sortByKey: "last_message", text: this.$t("dashboardView.listHeader.lastSeen") }
      ],
      RoleTypes: RoleTypes
    };
  },
  mounted() {
    this.fetchSensors();
  },
  methods: {
    ...mapActions("thiSensors", {
      getSensors: "getSensors"
    }),
    async fetchSensors() {
      this.getSensors();
    },
    formatValue(value) {
      if (value === null || value === undefined) {
        return this.$t("general.noData");
      }
      return Number(value).toFixed(2);
    },
    getLastSeen(dateString) {
      if (!dateString) {
        return this.$t("general.never").toUpperCase();
      }

      const dateTime = this.$moment(dateString);
      const now = this.$moment();
      const diff = now - dateTime;
      const diffInDays = Math.ceil(diff / 1000 / 60 / 60 / 24);

      if (diffInDays === 1) {
        const diffInHours = Math.ceil(diff / 1000 / 60 / 60);
        if (diffInHours === 1) {
          const diffInMinutes = Math.ceil(diff / 1000 / 60);
          return `${diffInMinutes} minutes ago`;
        }
        return `${diffInHours} hours ago`;
      }

      return `${diffInDays} days ago`;
    },
    searchData(searchText, sensors) {
      if (!searchText || searchText === "") {
        return sensors;
      }
      const searchedData = [];
      sensors.forEach(sensor => {
        if (
          Object.values(sensor).some(
            item =>
              item &&
              item
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
          )
        ) {
          searchedData.push(sensor);
        }
      });
      return searchedData;
    },
    sortData(sensors) {
      if (!this.sortBy.key) {
        return sensors;
      }
      return [...sensors].sort((a, b) => {
        let aKey = a[this.sortBy.key];
        let bKey = b[this.sortBy.key];

        let diff;
        if (["name", "deveui"].includes(this.sortBy.key)) {
          diff = this.sortBy.direction
            ? (bKey || "").localeCompare(aKey || "")
            : (aKey || "").localeCompare(bKey || "");
        } else if (this.sortBy.key === "last_message") {
          aKey = this.$moment(aKey || "2000-01-01").format("x");
          bKey = this.$moment(bKey || "2000-01-01").format("x");
          diff = aKey - bKey;
          if (this.sortBy.direction) diff *= -1;
        } else {
          diff = (aKey || 0) - (bKey || 0);
          if (this.sortBy.direction) diff *= -1;
        }
        return diff;
      });
    },
    setSortBy(sortBy) {
      this.sortBy.direction = !this.sortBy.direction ? true : false;
      this.sortBy.key = sortBy;
    },
    prevPage() {
      if (this.page > 1) this.page--;
    },
    nextPage() {
      if (this.page < this.totalPages) this.page++;
    },
    showMore() {
      this.sensorsPerPage += 100;
      this.page = 1;
    },
    updatePagination(length) {
      this.totalPages = Math.max(1, Math.ceil(length / this.sensorsPerPage));
    }
  },
  computed: {
    modalData() {
      return {
        reload: () => {
          this.fetchSensors();
        }
      };
    },
    ...mapState({
      sensorList(state) {
        const sensors = state.thiSensors.sensors || [];
        const searched = this.searchData(this.searchText, sensors);
        const sorted = this.sortData(searched);
        this.updatePagination(sorted.length);
        return sorted.slice((this.page - 1) * this.sensorsPerPage, this.page * this.sensorsPerPage);
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/_thi-sensors/thi-sensors.js